import {
  Button, ButtonToggle, ButtonToggleGroup, EXTRA_SMALL, SECONDARY, SMALL, TERTIARY
} from '@glu/buttons-react';
import { CircleArrowDownNextIcon, SquaresFourNextIcon, TriangleNextIcon } from '@glu/icons-react';
import { withStyles } from '@glu/theming';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const styles = {
  spacing: {
    margin: 10
  },
  spacingLarge: {
    marginLeft: 24
  }
};

const ButtonDemo = ({ classes }) => {
  const [toggleId, setToggleId] = useState(null);
  const [iconToggleId, setIconToggleId] = useState(null);

  return (
    <>
      <div>
        <Button className={classes.spacing} text="Primary" />
        <Button className={classes.spacing} text="Primary" size={SMALL} />
        <Button className={classes.spacing} text="Primary" size={EXTRA_SMALL} />
      </div>
      <div>
        <Button
          className={classes.spacing}
          text="Primary"
          aria-busy
        />
        <Button
          className={classes.spacing}
          text="Primary"
          size={SMALL}
          aria-busy
        />
        <Button
          className={classes.spacing}
          text="Primary"
          size={EXTRA_SMALL}
          aria-busy
        />
      </div>
      <div>
        <Button className={classes.spacing} text="Primary" disabled />
        <Button className={classes.spacing} text="Primary" disabled size={SMALL} />
        <Button className={classes.spacing} text="Primary" disabled size={EXTRA_SMALL} />
      </div>
      <div>
        <Button className={classes.spacing} text="Secondary" variant={SECONDARY} />
        <Button className={classes.spacing} text="Secondary" variant={SECONDARY} size={SMALL} />
        <Button
          className={classes.spacing}
          text="Secondary"
          variant={SECONDARY}
          size={EXTRA_SMALL}
        />
      </div>
      <div>
        <Button
          className={classes.spacing}
          text="Secondary"
          variant={SECONDARY}
          aria-busy
        />
        <Button
          className={classes.spacing}
          text="Secondary"
          variant={SECONDARY}
          size={SMALL}
          aria-busy
        />
        <Button
          className={classes.spacing}
          text="Secondary"
          variant={SECONDARY}
          size={EXTRA_SMALL}
          aria-busy
        />
      </div>
      <div>
        <Button className={classes.spacing} text="Secondary" disabled variant={SECONDARY} />
        <Button
          className={classes.spacing}
          text="Secondary"
          disabled
          variant={SECONDARY}
          size={SMALL}
        />
        <Button
          className={classes.spacing}
          text="Secondary"
          disabled
          variant={SECONDARY}
          size={EXTRA_SMALL}
        />
      </div>
      <div>
        <Button className={classes.spacingLarge} text="Tertiary" variant={TERTIARY} />
        <Button className={classes.spacingLarge} text="Tertiary" variant={TERTIARY} size={SMALL} />
        <Button
          className={classes.spacingLarge}
          text="Tertiary"
          variant={TERTIARY}
          size={EXTRA_SMALL}
        />
      </div>
      <div>
        <ButtonToggleGroup
          className={classes.spacing}
          selectedButtonId={toggleId}
          onButtonSelected={setToggleId}
        >
          <ButtonToggle id={1}>Left</ButtonToggle>
          <ButtonToggle id={2}>Middle</ButtonToggle>
          <ButtonToggle id={3}>Right</ButtonToggle>
        </ButtonToggleGroup>
      </div>
      <div>
        <ButtonToggleGroup
          className={classes.spacing}
          selectedButtonId={iconToggleId}
          onButtonSelected={setIconToggleId}
        >
          <ButtonToggle id={1}>
            <SquaresFourNextIcon focusable={false} noIconWrapper />
          </ButtonToggle>
          <ButtonToggle id={2}>
            <TriangleNextIcon focusable={false} noIconWrapper />
          </ButtonToggle>
          <ButtonToggle id={3}>
            <CircleArrowDownNextIcon focusable={false} noIconWrapper />
          </ButtonToggle>
        </ButtonToggleGroup>
      </div>
    </>
  );
};

ButtonDemo.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired
};

export default withStyles(styles)(ButtonDemo);
